import React, { useState, useContext, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import SingInForm from "../pages/auth/forms/SingInForm";
import { UiAuthContainer } from "../_uiComponents/common/custom/header/UiTopNavElements";
import UiInlineErrorMessage from "../_uiComponents/form/UiInlineErrorMessage";
import UiInlineSuccessMessage from "../_uiComponents/form/UiInlineSuccessMessage";
import { Context } from "../../_context/Store";
import { participantUrl } from "../../_redux/_constants";
import { UiLoginScreenContentContainer, UiLoginScreenContent,UiAuthTopWr } from "../_uiComponents/common/custom/header/UiTopNavElements";

export default function Application(props) {
    const [state, dispatch] = useContext(Context);
    const location = useLocation();
    const [isRewardUrl, setIsRewardUrl] = useState(false);

    useEffect(() => {
        const hostname = window.location.hostname;

        if (
            hostname.includes(participantUrl.RENAULT_REWARDS_URL) ||
            hostname.includes("myrgrewards.com")
        ) {
            setIsRewardUrl(true);
            dispatch({
                type: "REDIRECT_MODAL",
                payload: {
                    show: true,
                    title: "Exciting News!",
                    message:
                        "Your RGRewards account has moved to the Trade Loyalty Club (TLC). Now, you can access all your Renault Rewards and exclusive offers in one convenient place.",
                    redirectUrl: "https://rgtlc.com/",
                },
            });
        }
    }, []);

    if (isRewardUrl) {
        return null;
    }

    return (
        <>
            <UiAuthContainer>
                <UiLoginScreenContentContainer>
                    {/* <UiLoginScreenContent /> */}
                    <UiAuthTopWr>
                        <h2>Login</h2>
                        {/* <UiInlineErrorMessage/>
                        <UiInlineSuccessMessage/> */}
                        <SingInForm />
                    </UiAuthTopWr>
                </UiLoginScreenContentContainer>
            </UiAuthContainer>
        </>
    );
}
